import { Box, Tooltip } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import {
  DoneIcon,
  DoubleTickIcon,
  GmailLogoIcon,
} from "Components/Shared/Icons";
import { MerchantStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import type { FC, SVGProps } from "react";

const STATUS_TO_ICON: Record<
  MerchantStatus,
  FC<SVGProps<SVGSVGElement>> | null
> = {
  [MerchantStatus.InDraft]: null,
  [MerchantStatus.InvitedWaitingForConfirmation]: GmailLogoIcon,
  [MerchantStatus.Onboarding]: DoneIcon,
  [MerchantStatus.WaitingForPaymentTerminal]: null,
  [MerchantStatus.Active]: DoubleTickIcon,
  [MerchantStatus.BlockedFinancialServices]: null,
};

const STATUS_TO_COLOR: Record<MerchantStatus, string> = {
  [MerchantStatus.InDraft]: "",
  [MerchantStatus.InvitedWaitingForConfirmation]: Colors.Border,
  [MerchantStatus.Onboarding]: "green",
  [MerchantStatus.WaitingForPaymentTerminal]: "",
  [MerchantStatus.Active]: "green",
  [MerchantStatus.BlockedFinancialServices]: "",
};

type Props = {
  status: MerchantStatus;
};

export const MerchantStatusCell = ({ status }: Props) => {
  const { t } = useResource();
  const Icon = STATUS_TO_ICON[status];
  const color = STATUS_TO_COLOR[status];

  return (
    <Tooltip title={t(Resources.Merchant.MerchantStatus[status])}>
      <Box display="flex" color={color}>
        {Icon && <Icon width="1rem" height="1rem" />}
      </Box>
    </Tooltip>
  );
};
